/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import IndexedList from '../../support/shared/IndexedList';
import Imm from '../../support/ImmutableHelpers';
import createFormElement from './FormElements/helpers/createFormElement';

import { FormField } from './FormElements/types/FormField';
import { FormDefinition } from '../../types/shared/FormDefinition';
import { Group } from '../../types/shared/Group';
import { FormFieldDefinition } from '../../types/shared/FormFieldDefinition';

const IS_INITIALIZED = {};

class FormModel {
  id: string = undefined as any;
  name: string = undefined as any;
  enabled: boolean = undefined as any;
  fields: IndexedList<FormField> = undefined as any;
  fieldDefs: Array<FormFieldDefinition> = undefined as any;
  groups?: Array<Group> = undefined as any;
  revision?: number = undefined as any;
  params?: any = undefined;
  created_at: string | null | undefined;
  modified_at: string | null | undefined;

  // TODO: Validate definition?
  constructor(
    definition: FormDefinition,
    isInitialized?: ObjectOf<any> | null | undefined,
  ) {
    if (isInitialized === IS_INITIALIZED) {
      Object.assign(this, definition);
      return;
    }
    this.id = definition.id;
    this.name = definition.name;
    this.enabled = definition.enabled ?? true;
    this.fieldDefs = definition.fields;
    let fields = [];

    for (let field of definition.fields) {
      let formElement = createFormElement(definition.id, field.type, field);
      if (formElement) {
        fields.push(formElement);
      }
    }

    this.fields = new IndexedList(fields);
    this.groups = definition.groups ?? [];
    this.created_at = definition.created_at
      ? new Date(definition.created_at).toJSON()
      : null;
    this.modified_at = definition.modified_at
      ? new Date(definition.modified_at).toJSON()
      : null;
  }

  update(updates: { [key: string]: unknown }) {
    // TODO: This is hacky shit. Let's fix this.
    let result = Imm.setProperties(this as any, updates);
    if (!(result instanceof FormModel)) {
      result = new FormModel(result, IS_INITIALIZED);
    }
    return result as FormModel;
  }

  toJSON(): FormDefinition {
    return {
      id: this.id,
      name: this.name,
      enabled: this.enabled,
      fields: this.fields.mapToArray((field: any) => field.toJSON()),
      groups: this.groups,
      params: this.params,
      revision: this.revision,
      created_at: this.created_at ? this.created_at : undefined,
      modified_at: this.modified_at ? this.modified_at : undefined,
    };
  }
}

export default FormModel;
